import { ButtonProps } from "@commonlibs";
import { LocaleTranslationResource } from "ui/locale/i18n.types";
import SendPointToUserModal from "../../containers/SendPointsToUserModal/SendPointsToUserModal";

export enum POINT_COLUMNS {
    MINTED = "minted",
    AVAILABLE = "available",
    CIRCULATING = "circulating",
    RATE = "rate",
    EXPIRATION = "expiration",
    TERMS_AND_CONDITIONS = "termsAndConditions",
    PRIVACY_POLICY = "privacyPolicy",
    PERSONAL_DATA_PROCESSING = "personalDataProcessing",
    ACTIONS = "actions",
}

export interface PointColumnAction {
    variant: ButtonProps["variant"];
    label: LocaleTranslationResource;
    modal: typeof SendPointToUserModal;
}
